import { useSelector } from 'react-redux'

import MarkdownReader from '@/components/MarkdownReader'
import {
  isPublisherReturnPolicySelector,
  returnPolicySelector, unredeemedAndReturnedWithinSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

import PurchaseDatePolicy from './PurchaseDatePolicy'

const TRANSLATION_KEY = 'return_policy.modal.rules'

const RegularStoreContent = () => {
  const isPublisherReturnPolicy = useSelector(isPublisherReturnPolicySelector)
  const returnPolicy = useSelector(returnPolicySelector)
  const isBulkIntegrationEnabled = useSelector(
    state => state.featureFlags.bulkIntegrationEnabled
  )

  const unredeemedAndReturned = useSelector(unredeemedAndReturnedWithinSelector)

  const {
    percentView,
    returnItemTotal,
    returnPastDays
  } = returnPolicy

  return (
    <>
      <p>{translate(`${TRANSLATION_KEY}.subtitle`)}</p>
      <ul>
        <PurchaseDatePolicy />
        <Choose>
          <When condition={percentView > 0}>
            <li>
              <MarkdownReader>
                {translate(
                  `${TRANSLATION_KEY}.percent_view_policy`,
                  { percent: percentView }
                )}
              </MarkdownReader>
            </li>
          </When>
          <When condition={percentView === 0}>
            <li>
              <MarkdownReader>
                {translate(`${TRANSLATION_KEY}.not_viewed_or_printed`)}
              </MarkdownReader>
            </li>
          </When>
        </Choose>
        <If condition={!isPublisherReturnPolicy}>
          <li>
            <p>{translate(`${TRANSLATION_KEY}.online_resource_policy`)}</p>
          </li>
        </If>
        <li>
          <p>{translate(`${TRANSLATION_KEY}.return_same_item`)}</p>
        </li>
        <li>
          <p>{translate(`${TRANSLATION_KEY}.only_vst_items`)}</p>
        </li>
        <li>
          <MarkdownReader>
            {translate(
              `${TRANSLATION_KEY}.return_max_policy`,
              { returnItemTotal, returnPastDays }
            )}
          </MarkdownReader>
        </li>
      </ul>
      <If condition={isBulkIntegrationEnabled}>
        <p>
          <MarkdownReader>
            {translate(`${TRANSLATION_KEY}.purchased_as_gift`)}
          </MarkdownReader>
        </p>
        <ul>
          <Choose>
            <When condition={unredeemedAndReturned > 0}>
              <li>
                <MarkdownReader>
                  {translate(
                      `${TRANSLATION_KEY}.exception_redemption_bullet`,
                      { days: unredeemedAndReturned }
                    )}
                </MarkdownReader>
              </li>
            </When>
            <Otherwise>
              <li>
                <MarkdownReader>
                  {translate(`${TRANSLATION_KEY}.standard_redemption_bullet`)}
                </MarkdownReader>
              </li>
            </Otherwise>
          </Choose>
        </ul>
      </If>
    </>
  )
}

export default RegularStoreContent
